import { Body, Flex, VStack, ListDivider, Box } from 'designsystem';
import { ForumFilmQuery } from '../gql/api';
import { FC } from 'react';
import { FormattedNumber } from 'react-intl';

interface Props {
    financiers: ForumFilmQuery['film']['financiers'];
}

const FinanciersList: FC<Props> = ({ financiers }) => (
    <VStack alignItems="start" spacing={4} divider={<ListDivider />} mb={3}>
        {financiers.map(({ id, name, contribution }) => (
            <Flex key={id} minW={['100%', null, '368px']} w="100%">
                <Box flex={2}>
                    <Body>{name}</Body>
                </Box>
                <Box ml="auto" flex={1}>
                    <Body textAlign="right">
                        <FormattedNumber value={contribution} minimumFractionDigits={contribution % 1 === 0 ? 0 : 2}>
                            {formattedNumber => <>€ {formattedNumber}</>}
                        </FormattedNumber>
                    </Body>
                </Box>
            </Flex>
        ))}
    </VStack>
);

export default FinanciersList;
